import { object } from 'common/helpers'


export const initialState = {
  searchValue: '',
  isBestsellers: false,
  exactBrandMatch: false,
  isExactTypeMatch: false,
  items: [],
  brand: null,
  algoliaItems: {},
}

export const set = (state, payload) => (
  { ...state, ...payload }
)

export const setSearchValue = (state, payload) => (
  { ...initialState, searchValue: payload }
)

export const setAlgoliaItems = (state, payload) => (
  object.set(state, 'algoliaItems', payload)
)

export const clear = () => initialState
